import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'
import ReactDOM from 'react-dom';

import PropTypes from "prop-types";
import AppLink from "../AppLink";
import Icon from "../Icon";
import {urlChanged} from "../../mixins/urls";
import WithUserState from "../user/WithUserState";
import SignUpButton from "../user/SignUpButton";
import SignInButton from "../user/SignInButton";
import SignOutButton from "../user/SignOutButton";

class BurgerMenu extends Component {
  static propTypes = {
    opened: PropTypes.bool.isRequired,
    callback: PropTypes.func.isRequired,
    menu: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      activeItem: null
    }
  }

  onToggleChildren(e) {
    let elem = e.currentTarget.closest(".category-container").querySelector(".category-children");
    if (!elem) {
      return this.props.history.push(e.currentTarget.dataset.href);
    }

    elem.classList.toggle("visible");
  }

  onUserToggle(e) {
    e.target.closest(".burger-menu").querySelector(".user-container .category-children").classList.toggle("visible");
  }

  onCloseCallback() {
    document.querySelectorAll('.category-children.visible').forEach((child) => {
      // child.classList.remove('visible');
    });

    this.detectActiveItem();

    this.props.callback();
  }

  detectActiveItem() {
    const { pathname } = this.props.location;

    let i = this.props.menu.find(item => {
      return ((pathname === (item.url) || (item.children && item.children.find((c) => { return c.url === pathname; })) !== undefined)) && item.children && item.children.length > 0;
    });

    this.setState({
      activeItem: i ? i.url : null
    });
  }

  componentDidMount() {
    this.detectActiveItem();
  }

  componentDidUpdate(prevProps) {
    let changed = urlChanged(prevProps, this.props);

    if (this.props.opened && changed) {
      this.onCloseCallback();
    }

    if (changed || prevProps.menu.length !== this.props.menu.length) {
      this.detectActiveItem();
    }
  }

  render() {
    const { opened, menu } = this.props;

    const userArea = (
      <div className={'user-area'}>
        <WithUserState state={"loggedIn"}>
          <button onClick={this.onUserToggle.bind(this)}>
            <div className={'row no-gutters'}>
              <div className={'col-11'}>Your Area</div>
              <div className={'col-1'}><Icon className={'white'} icon={"user"}/></div>
            </div>
          </button>
        </WithUserState>

        <WithUserState state={"loggedOut"}>
          <div className={'row no-gutters'}>
            <div className={'col-6'}>
              <SignUpButton>Register <Icon icon={'pen'}/></SignUpButton>
            </div>
            <div className={'col-6'}>
              <SignInButton>Login <Icon icon={'arrow-right'}/></SignInButton>
            </div>
          </div>
        </WithUserState>
      </div>
    );

    return ReactDOM.createPortal(
      <React.Fragment>
        {opened && (
          <div className={'burger-fadeoff'} onClick={this.onCloseCallback.bind(this)}>
            <button>
              <div>Close</div>
              <Icon icon={'times'} />
            </button>
          </div>
        )}
        <div key={"active-" + this.state.activate} className={'burger-menu ' + (opened ? 'open' : 'closed')}>
          {userArea}
          <div className={'divider'} />

          {menu.map(item => {
            return (
              <div key={item.url} className={'category-container'}>
                <button onClick={this.onToggleChildren.bind(this)} data-href={item.url}>
                  <div className={'row no-gutters'}>
                    <div className={'col-11'}>{item.name || item.title}</div>
                    <div className={'col-1'}>
                      {item.icon && <Icon icon={item.icon} />}
                    </div>
                  </div>
                </button>
                {item.children && item.children.length > 0 && (
                  <div className={'category-children ' + (this.state.activeItem === item.url ? "visible" : "")}>
                    {userArea}

                    <button className={'back-button'} onClick={this.onToggleChildren.bind(this)}>
                      <div className={'row no-gutters'}>
                        <div className={'col-1'}><Icon icon={'arrow-left'} /></div>
                        <div className={'col-10'}>back</div>
                        <div className={'col-1'}><Icon icon={item.icon} /></div>
                      </div>
                    </button>

                    <div className={'divider'} />
                    <AppLink to={item.url} className={'title'}>{item.name || item.title}</AppLink>
                    <div className={'divider'} />

                    <AppLink to={item.url}>Show All</AppLink>
                    <div className={'divider'} />
                    {item.children.map(child => {
                      return <AppLink key={child.url} to={child.url}>{(child.name || child.title)}</AppLink>
                    })}
                  </div>
                )}
              </div>
            )
          })}

          <WithUserState state={"loggedIn"}>
            <div className={'user-container'}>
              <div className={'category-children'}>
                <button className={'back-button'} onClick={this.onUserToggle.bind(this)}>
                  <i className={'fa fa-arrow-left'} /> back to overview
                </button>

                <div className={'divider'} />
                <AppLink to={"/user"}>Overview</AppLink>
                <AppLink to={"/user/favorites"}>Favorites</AppLink>
                <AppLink to={"/user/subscriptions/new"}>Subscriptions</AppLink>
                <div className={'divider'} />
                <SignOutButton>Sign Out</SignOutButton>
              </div>
            </div>
          </WithUserState>
        </div>
      </React.Fragment>,
      document.body
    );
  }
}

export default withRouter(BurgerMenu);